export default {
  DeviceSuppliers: [{
    value: "0",
    label: "海康"
  },
    {
      value: "1",
      label: "大华"
    }]
}
